var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-clear-div",on:{"click":_vm.clearInputData}},[_c('i',{staticClass:"iconfont icon-close_circle_surface"})])}
var staticRenderFns = []

export { render, staticRenderFns }